<template>
    <div>
        <div class="card  border-0 ">
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-9">
                        <!-- <local :valor_entrada="control.idlocal" v-model="control.idlocal" @evento="control.idlocal=$event" class="text-center"  data-vv-name="local" v-validate="'required'" /> -->
                        <select data-vv-name="personal" v-validate="'required'" v-model="control.dnipersonal" class="form-control font-weight-bold text-center"  name="personal" >
						<option value="">Seleccione Personal</option>
						<option v-for="p in personal" :key="p.dni" :value="p.dni">{{p.vendedor}}</option>
					</select>
                        <error :attribute_name="'personal'" :errors_form="errors" />
                    </div>
                    <div class="col-lg-3">
                        <select  v-model="control.tipo"  data-vv-name="tipo" v-validate="'required'" class="form-control font-weight-bold text-center">
                            <option value="">Seleccione Tipo</option>
                            <option value="1">GLP</option>
                            <option value="2">GNV</option>
                            <!-- <option value="3">TRIMOVIL</option> -->
                            <option value="4">MODIFICACIÓN</option>
                        </select>
                        <error :attribute_name="'tipo'" :errors_form="errors" />
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-lg-2">
                        <input type="text" v-model="control.inicial" data-vv-name="inicial" v-validate="'required|numeric'"   placeholder="Ingrese Inicial" class="form-control" />
                          <error :attribute_name="'inicial'" :errors_form="errors" />
                    </div>
                    <div class="col-lg-2">
                        <input type="text" v-model="control.final"  data-vv-name="final" v-validate="'required|numeric'" placeholder="Ingrese Final" class="form-control" />
                          <error :attribute_name="'final'" :errors_form="errors" />
                    </div>
                    <div class="col-lg-5">
                        <textarea placeholder="Ingrese sus observaciones o notas" v-model="control.observaciones" class="form-control"></textarea>
                    </div>
                    <div class="col-lg-3">
                        <button v-if="nuevo" @click="validarFormulario()" class="btn btn-indigo btn-block"><i class="fa fa-save"></i>
                            GUARDAR</button>
                        <button v-else class="btn btn-info btn-block" @click="validarFormulario()"><i class="fa fa-save"></i> EDITAR</button>
                    </div>
                </div>
                <hr>
            </div>
        </div>
    </div>
</template>
<script>
   
    import error from '../../../components/compartidos/Error.vue';
   import axios from 'axios'
    export default {
        name: "Control",
        props: ["registro", 'nuevo'],
        components: {
           
            error,
          
        },
        data() {
            return {
                personal:[],
                control: {
                    Id:"",
                    idlocal:"",
                    dnipersonal:"",
                    local: "",
                    tipo: "1",
                    inicial: "",
                    final: "",
                    observaciones: "",
                    estado: "1",
                    actual:"",
                },
            }
        },
        beforeMount() {
            if (!this.nuevo) {
                this.control = {
                    ...this.registro
                };
            }
        },
        created(){
            this.cargarPersonal();
        },
        methods: {
            validarFormulario() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        if (this.nuevo) {
                            
                            this.$emit('guardar', this.control);
                        } else {
                            this.$emit('actualizar', this.control);
                        }
                        return;
                    }
                });
            },
            cargarPersonal() {
				
				axios.post(this.URL_BASE() + "personas/read/").then(respuesta => {
					if (respuesta.data.msg == 'exito') {
						this.personal=respuesta.data.data;
					}
				}).catch(function (error) {
					error.log("er store" + error);
				});
			},
        },
        watch: {
            nuevo(newQuestion, oldQuestion) {
                this.control = {
                    ...this.registro
                };
              
            },
            
        }
    }
</script>